import { createFeatureActionNamer } from '../../../../../redux/action-name';

const getActionName = createFeatureActionNamer('death-contact-details');

export const ADD_CLAIMANT_RECORD = getActionName('ADD_CLAIMANT_RECORD');
export const DELETE_CLAIMANT_RECORD = getActionName('DELETE_CLAIMANT_RECORD');
export const UPDATE_CLAIMANT_RECORD = getActionName('UPDATE_CLAIMANT_RECORD');
